import { Component } from '@angular/core';

@Component({
  selector: 'app-semapplicants',
  templateUrl: './semapplicants.component.html',
  styleUrls: ['./semapplicants.component.css']
})
export class SemapplicantsComponent {

}
